import { Modal, ModalDialog, Select, Option, Input, RadioGroup, Radio, Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import totalLocationData from "../../../../../../data/locationdata";
import { koreanLocationToEnglish } from "../../../../../../data/locationFuntion";
import { postFetch } from "../../../../../../fetch/fetch";


const RegisterWorkManually: React.FC<any> = (props) => {

    const [location, setLocation] = useState<string | undefined>(undefined);
    const [korean, setKorean] = useState<string>("");
    const [realMinutes, setRealMinutes] = useState<number>(0);
    const [isDefault, setIsDefault] = useState<boolean>(true);
    const [isRequested, setIsRequested] = useState<boolean>(false);
    const [startTime, setStartTime] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false);


    useEffect(() => {

        if (props.user && props.open) {

            const location = koreanLocationToEnglish(props.user.location);

            console.log(props.user.location);
            setLocation(location);
        }

        if(!props.open){
            setKorean("");
            setRealMinutes(0);
            setIsDefault(true);
            setIsRequested(false);
            setStartTime("");
        }

    }, [props.user, props.open]);

    const submit = async () => {

        try{

            if(!location || !korean || !realMinutes || !startTime || !props.selectedDate || !props.user){
                return;
            }

            const data : any = {
                korean,
                realMinutes,
                isDefault,
                isRequested,
                startTime,
                date : props.selectedDate.getTime(),
                location,
                userId : props.user.id,
            }

            setLoading(true);

            const result : any = await postFetch("/dashboard/salary/registerworkmanually", data);

            if(result.message === "success"){
                props.setUpdate(Math.random());
                props.notify("success", "근무가 성공적으로 등록되었습니다.");
                props.onClose();
            }

            setLoading(false);

        }catch(e){
            console.log(e);
        }

    }

    useEffect(() => {

        if(!korean || !realMinutes || !startTime || !location){
            setDisabled(true);
            return;
        }

        setDisabled(false);

    }, [korean, realMinutes, startTime, location]);

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
        >
            <ModalDialog>
                <div style={{
                    width: "300px"
                }}>
                    {
                        (props.selectedDate)
                            ?
                            <div>
                                <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "1px" }}>
                                    {props.selectedDate.getFullYear()}년 {props.selectedDate.getMonth() + 1}월 {props.selectedDate.getDate()}일 {["일", "월", "화", "수", "목", "금", "토"][props.selectedDate.getDay()]}요일
                                </div>
                                <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "15px" }}>
                                    근무 수동 등록
                                </div>
                                <div>
                                    <div style={{
                                        fontWeight: 600
                                    }}>
                                        근무 지점 선택
                                    </div>
                                    <div>
                                        <Select placeholder="지점을 선택해주세요"
                                            value={location}
                                            onChange={(e: any, newValue: any) => {
                                                console.log(newValue);
                                                setLocation(newValue)
                                            }}
                                            style={{ width: "300px", marginTop: "6px" }}
                                        >
                                            {
                                                totalLocationData.map((data, index: number) => {

                                                    if (!data.academy.includes("sunbae") && !data.academy.includes("bundangsunbae")) {
                                                        return;
                                                    }

                                                    if (data.english === "total") {
                                                        return;
                                                    }

                                                    return (
                                                        <Option key={index} value={data.english}>
                                                            {data.korean}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </div>
                                    <div style={{
                                        fontWeight: 600,
                                        marginTop: "15px"
                                    }}>
                                        업무 이름 입력
                                    </div>
                                    <div style={{ marginTop: "6px" }}>
                                        <Input
                                            value={korean}
                                            onChange={(e) => setKorean(e.target.value)}
                                            fullWidth
                                        />
                                    </div>
                                    <div style={{
                                        fontWeight: 600,
                                        marginTop: "15px"
                                    }}>
                                        업무 시작 시간 (HH:MM)
                                    </div>
                                    <div style={{ marginTop: "6px" }}>
                                        <Input
                                            type="time"
                                            value={startTime}
                                            onChange={(e) => setStartTime(e.target.value)}
                                            fullWidth
                                        />
                                    </div>
                                    <div style={{
                                        fontWeight: 600,
                                        marginTop: "15px"
                                    }}>
                                        실제 근무 시간 (분)
                                    </div>
                                    <div style={{ marginTop: "6px" }}>
                                        <Input
                                            type="number"
                                            value={realMinutes}
                                            onChange={(e) => setRealMinutes(parseInt(e.target.value))}
                                            fullWidth
                                        />
                                    </div>
                                    <div style={{
                                        fontWeight: 600,
                                        marginTop: "15px"
                                    }}>
                                        기본 근무 여부
                                    </div>
                                    <div style={{ marginTop: "9px" }}>
                                        <RadioGroup
                                            orientation="horizontal"
                                            value={isDefault ? "yes" : "no"}
                                            onChange={(e: any) => {
                                                if (e.target.value === "yes") {
                                                    setIsDefault(true);
                                                } else {
                                                    setIsDefault(false);
                                                }
                                            }}
                                        >
                                            <Radio value="yes"
                                                label={<span> 기본 근무</span>}
                                            />
                                            <Radio value="no"
                                                label={<span> 대타</span>}
                                            />
                                        </RadioGroup>
                                    </div>
                                    {
                                        !isDefault
                                            ?
                                            <>
                                                <div style={{
                                                    fontWeight: 600,
                                                    marginTop: "15px"
                                                }}>
                                                    본사 요청 대타 여부
                                                </div>
                                                <div style={{ marginTop: "9px" }}>
                                                    <RadioGroup
                                                        orientation="horizontal"
                                                        value={isRequested ? "yes" : "no"}
                                                        onChange={(e: any) => {
                                                            if (e.target.value === "yes") {
                                                                setIsRequested(true);
                                                            } else {
                                                                setIsRequested(false);
                                                            }
                                                        }}
                                                    >
                                                        <Radio value="yes"
                                                            label={<span>본사 요청 대타</span>}
                                                        />
                                                        <Radio value="no"
                                                            label={<span>본사 미요청 대타</span>}
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            </>
                                            :
                                            ""
                                    }

                                </div>
                            </div>
                            :
                            ""
                    }
                    <div style={{
                        marginTop: "25px",
                    }}>
                        <Button
                            variant="solid"
                            fullWidth
                            onClick={submit}
                            loading={loading}
                            disabled={disabled}
                        >
                            근무 수동 등록하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    )
}

export default RegisterWorkManually;